// Libraries

// Supermove
import {useEffect, useState, useTrackEvent} from '@supermove/hooks';

// App
import ProjectWidgetKind from '@shared/modules/Project/enums/ProjectWidgetKind';

const useWidgetAnalytics = ({
  contextName,
  params,
}: {
  contextName: string;
  params: Record<string, any>;
}) => {
  const [prevWidget, setPrevWidget] = useState();

  const {trackEvent} = useTrackEvent({
    // Event name should not be changed. It should be derived from the enum, made human readable.
    eventName: `Viewed ${ProjectWidgetKind.getDisplay(params.widget)} Widget`,
    eventType: `${contextName} View`,
  });

  useEffect(() => {
    const hasWidgetChange = params.widget && prevWidget && params.widget !== prevWidget;

    if (hasWidgetChange) {
      trackEvent();
      setPrevWidget(params.widget);
    }
  }, [params.widget]);
};

export default useWidgetAnalytics;
